import React, { useState, useRef } from 'react';
import './Contact.css';
import { Box, Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import emailjs from '@emailjs/browser';
import { config } from '../../assets/config';

function ContactForm() {
  const form = useRef();

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    enquiry: '',
  });

  // Handle input change
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  // Send email and reset form after success
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(config.serviceId, config.templateId, form.current, config.publicKey)
      .then((result) => {
        console.log('SUCCESS!', result.text);
        alert('Enquiry Sent Successfully!');

        // Reset form fields
        setFormData({
          name: '',
          phone: '',
          email: '',
          enquiry: '',
        });

        // Reset actual form HTML element
        form.current.reset();
      }, (error) => {
        console.error('FAILED...', error.text);
        alert('Failed to send enquiry. Please try again.');
      });
  };

  return (
    <div id="contact-form">
      <Box sx={{ width: { xs: '100%', sm: '60%' } }}>
        <form 
          ref={form} 
          style={{ display: 'flex', flexDirection: 'column' }} 
          onSubmit={sendEmail}
        >
          <TextField
            id="name"
            name="name"
            label="Name"
            variant="outlined"
            sx={{ marginBottom: '1rem' }}
            value={formData.name}
            onChange={handleChange}
          />
          <TextField
            id="phone"
            name="phone"
            label="Phone Number"
            variant="outlined"
            sx={{ marginBottom: '1rem' }}
            value={formData.phone}
            onChange={handleChange}
          />
          <TextField
            id="email"
            name="email"
            label="Email"
            variant="outlined"
            sx={{ marginBottom: '1rem' }}
            value={formData.email}
            onChange={handleChange}
          />
          <TextField
            id="enquiry"
            name="enquiry"
            label="Enquiry"
            multiline
            variant="outlined"
            maxRows={4}
            sx={{ marginBottom: '1rem' }}
            value={formData.enquiry}
            onChange={handleChange}
          />
          <Box>
            <Button 
              type="submit"
              variant="contained" 
              size="large"
              sx={{
                textTransform: 'capitalize',
                backgroundColor: '#00bf63',
                '&:hover': {
                  backgroundColor: '#00c05a',
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </form>
      </Box>
    </div>
  );
}

export default ContactForm;
